import axios from "axios";

const api = axios.create({
  baseURL: "https://api.microwellindustries.com/api",
});

export default api;
